import { RootState } from "modules";
import { createSelector } from "reselect";

const animefurusatoState = (state: RootState) => state.pages.lp.animefurusato;

const showsDeductionFlowDetail = createSelector(animefurusatoState, (state) => state.showsDeductionFlowDetail);
const deductionStepId = createSelector(animefurusatoState, (state) => state.deductionStepId);

export const animefurusatoSelector = {
  showsDeductionFlowDetail,
  deductionStepId
};
